import _ from 'lodash';
import React from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

import {
  Form,
  Icon,
  Popup,
} from 'semantic-ui-react';

import {
  Label,
} from './styles';

const InputDatePickerField = ({
  field, // { name, value, onChange, onBlur }
  form: { errors, touched },
  ...props
}) => (
  <>
    <Form.Field>
      {props.labelText && (
        <Label
          error={_.get(errors, field.name) && _.get(touched, field.name)}
          fontSize={props.labelFontSize}
          weight={props.labelWeight}
          color={props.labelColor}
        >
          {props.labelText}
          {props.content && <Popup trigger={<Icon name="info circle" />} content={props.content} />}
        </Label>
      )}

      <DatePicker
        name={field.name}
        onChange={(date) => props.onChange(field.name, date)}
        selected={field.value}
        maxDate={props.maxDate}
      />
    </Form.Field>
  </>
);

InputDatePickerField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }).isRequired,
  labelText: PropTypes.string,
  labelFontSize: PropTypes.string,
  labelWeight: PropTypes.string,
  labelColor: PropTypes.string,
  content: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func.isRequired,
};

InputDatePickerField.defaultProps = {
  labelText: undefined,
  labelFontSize: undefined,
  labelWeight: undefined,
  labelColor: undefined,
  content: undefined,
  maxDate: undefined,
};

export default InputDatePickerField;
